module.exports = __webpack_public_path__ + "static/media/web.eb469d52.config";